import React from 'react';
import * as R from 'ramda';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { Button, SvgIcon } from '@material-ui/core';
import * as Icons from '@material-ui/icons';

import { useAuth } from '../../hooks';

import {
  DataTable,
  Can,
} from '../../components';

import getUsers from '../../services/users/getUsers';
import getAllUserFunctions from '../../utils/getAllUserFunctions';
import getFunctions from '../../services/functions/getFunctions';
import deleteFunction from '../../services/functions/deleteFunction';
import getUserName from '../../services/users/getUserName';
import getDeletedCompanies from '../../services/companies/getDeletedCompanies';
import restoreDeletedCompany from '../../services/companies/restoreDeletedCompany';

import formatDate from '../../utils/formatDate';

const DeletedCompaniesList = () => {
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [deletedCompanies, setDeletedCompanies] = React.useState([]);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [selectedFunction, setSelectedFunction] = React.useState({});
  const [functionGotDeleted, setFunctionGotDeleted] = React.useState(true);
  const [tableData, setTableData] = React.useState([]);

  const [searchQuery, setSearchQuery] = React.useState('');
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [dataCount, setDataCount] = React.useState(0);

  const {
    userAccessToken,
    userSetTokenLikeExpired,
  } = useAuth();

  const columns = [
    { name: 'Id', options: { display: false } },
    { name: 'Nome' },
    { name: 'Data da Criação', options: { sort: false } },
    { name: 'Data da Deleção', options: { sort: false } },
    { name: 'Proprietário', options: { sort: false } },
  ];

  const getDeletedCompaniesList = async () => {
    const deletedCompaniesResponse = await getDeletedCompanies({
      accessToken: userAccessToken,
      page,
      pageSize,
      searchQuery,
      setTokenLikeExpired: userSetTokenLikeExpired,
    });

    if (R.isNil(deletedCompaniesResponse)) return;

    const [data, amount] = deletedCompaniesResponse;

    setDataCount(amount);
    setDeletedCompanies(data);
  };

  React.useEffect(() => {
    setLoading(true);
    getDeletedCompaniesList();

    setLoading(false);
  }, [functionGotDeleted, page, pageSize, searchQuery]);

  React.useEffect(() => {
    const data = [];

    deletedCompanies.map(element => {
      const formattedDeletedDate = format(new Date(element.deleted_at), 'dd/MM/yyyy, hh:mm:ss a');

      data.push([
        element.id,
        element.name,
        element.date_created,
        formattedDeletedDate,
        element.owner_user?.name || '',
      ]);
    });
    setTableData(data);
  }, [deletedCompanies]);

  const onAddFunctionClicked = () => {
    history.push('/functions/create');
  };

  const onUpdateFunctionClicked = (id) => {
    history.push(`/functions/update/${id}`);
  };

  const onDeleteFunctionClicked = async (id) => {
    const deleteFunctionResponse = await deleteFunction({
      accessToken: userAccessToken, id,
    });

    if (deleteFunctionResponse) getDeletedCompaniesList();
  };

  const onRestoreClicked = async (id) => {
    const restoreDeleted = await restoreDeletedCompany({
      accessToken: userAccessToken,
      id,
    });

    if (restoreDeleted) getDeletedCompaniesList();
  };

  return (
    <Can
      perform="Functions/List"
      yes={() => (
        <div style={{ padding: '1em' }}>
          <DataTable
            isDeleteTable
            count={dataCount}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            title="Empresas Apagadas"
            columns={columns}
            data={tableData}
            onRestoreClicked={onRestoreClicked}
            onUpdateClicked={onUpdateFunctionClicked}
            onDeleteClicked={onDeleteFunctionClicked}
            addRegisterLabel="Criar Função"
            addRegisterLink="/functions/create"
            emptyTableTitle="Esta tabela não possui empresas a exibir"
            isGuestTable
          />
        </div>
      )}
      no={() => <Redirect to="/main" />}
    />
  );
};

export default DeletedCompaniesList;
